import {
  useLoadingStore,
  selectLoading,
} from '@/modules/shared/stores/loadingStore'
import { axiosInstance } from '@/modules/shared/lib/axios'
import { ViolationModel } from '@/app/models/violationModel'
import { GroupedViolationModel } from '@/app/models/groupedViolationModel'
import { format } from 'date-fns'
import { AttestationModel } from '@/app/models/attestation/attestationModel'
import { downloadFile } from '@/modules/printouts/services/BaseService'

const useViolationService = () => {
  const startLoading = useLoadingStore((s) => s.startLoading)
  const getViolations = async ({
    companyId,
    driverId,
    startTime,
    endTime,
  }: {
    companyId: string
    driverId: number
    startTime: string
    endTime: string
  }): Promise<ViolationModel[]> => {
    const stopLoading = startLoading()
    try {
      const res = await axiosInstance.get(
        `api/${companyId}/violation?&driverId=${driverId}&startTime=${startTime}&endTime=${endTime}`,
      )
      return res.data || []
    } catch (err) {
      console.error('Error fetching violations:', err)
      return []
    } finally {
      stopLoading()
    }
  }

  const getContractDays = async ({
    companyId,
    driverId,
    startTime,
    endTime,
  }: {
    companyId: string
    driverId: number
    startTime: string
    endTime: string
  }): Promise<number | null> => {
    try {
      const res = await axiosInstance.get(
        `api/${companyId}/violation/contractDays?driverId=${driverId}&startTime=${startTime}&endTime=${endTime}`,
      )
      return typeof res.data === 'number' ? res.data : null
    } catch (err) {
      console.error('Error fetching contract days:', err)
      return null
    }
  }

  const getGroupedViolations = async ({
    companyId,
    drivers,
    startTime,
    endTime,
  }: {
    companyId: string
    drivers: number[]
    startTime: Date
    endTime: Date
  }): Promise<GroupedViolationModel[]> => {
    const res = await axiosInstance.post(
      `api/${companyId}/violation/groupedViolationInfo`,
      {
        drivers: drivers.map(String),
        startTime: format(startTime, 'YYYY-MM-DD HH:mm'),
        endTime: format(endTime, 'YYYY-MM-DD HH:mm'),
      },
    )
    return res.data || []
  }


  const calculateViolations = async ({
    companyId,
    id,
  }: {
    companyId: string
    id: string
  }): Promise<any> => {
    const stopLoading = startLoading()
    try {
      const res = await axiosInstance.post(
        `api/${companyId}/violation/calculate`,
        {
          companyId,
          id,
        },
      )
      return res.data
    } catch (err) {
      console.error('Error calculating violations:', err)
      throw err
    } finally {
      stopLoading()
    }
  }

  const generateViolationAttestation = ({
    companyId,
    attestation,
  }: {
    companyId: string
    attestation: AttestationModel
  }) =>
    // @TODO
    downloadFile(
      `api/${companyId}/driverCalendar/generateAttestation`,
      attestation,
    )

  return {
    getViolations,
    getContractDays,
    getGroupedViolations,
    generateViolationAttestation,
    calculateViolations,
  }
}

export default useViolationService
